import { trackEventGA4 } from '../gtm';

export const trackClickFooterPartner = async (partnerName: string) => {
    await trackEventGA4('footer_partner_click', { partner_name: partnerName });
};
